import {
  BulkSendTeacherPaymentFailureReason,
  bulkSendTeacherPaymentFailureReasonToLabel,
  BulkSendTeacherPaymentSummary,
} from '@airreading/common/data';

type Props = {
  response: BulkSendTeacherPaymentSummary;
};

export const BuildToastResponse = ({ response }: Props) => {
  const success = response.results.length;

  const failuresByReason = response.failures.reduce<Record<BulkSendTeacherPaymentFailureReason, string[]>>(
    (acc, { id, reason }) => {
      if (!acc[reason]) {
        acc[reason] = [];
      }
      acc[reason].push(id);
      return acc;
    },
    {} as Record<BulkSendTeacherPaymentFailureReason, string[]>,
  );

  return (
    <div className="flex flex-col">
      {success !== 0 && <span>✅ {success} actions completed successfully</span>}
      {Object.entries(failuresByReason).map(([reason, ids]) => (
        <span key={reason}>
          {(reason as BulkSendTeacherPaymentFailureReason) === 'unknown' ? (
            <>❌ {ids.length} actions failed</>
          ) : (
            <>
              💳 {ids.length} actions could not be completed due to
              {bulkSendTeacherPaymentFailureReasonToLabel[reason as BulkSendTeacherPaymentFailureReason]}
            </>
          )}
        </span>
      ))}
    </div>
  );
};
